// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__FVDm1","sec404":"notFound_sec404__6FRUk","notFoundContent":"notFound_notFoundContent__nPWXb"};